import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import { ReactNode } from 'react'

interface FullImageSectionProps {
    children?: ReactNode
    image?: string | { src: string; srcSet?: string; sizes?: string }
    height?: string | { xs?: string; md?: string; lg?: string }
    backgroundPosition?: string
    'aria-label'?: string
    [key: string]: any
}

const Index = (props: FullImageSectionProps) => {
    const { children, image = '', height = '95vh', ...rest } = props
    const isDev = process.env.NODE_ENV === 'development'
    
    // Handle both string and object image formats
    const imageSrc = typeof image === 'string' ? image : image?.src || ''
    const imageSrcSet = typeof image === 'object' ? image.srcSet : undefined

    
    // Build background image style with responsive support
    const backgroundImageStyle = imageSrcSet
        ? {
            // Use CSS custom properties for responsive images
            '--bg-image': `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.9)), url(${imageSrc})`,
            backgroundImage: 'var(--bg-image)',
            backgroundRepeat: 'no-repeat',
            // Use picture element approach via CSS (fallback to single image)
            '@media (max-width: 768px)': {
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.9)), url(${imageSrc})`,
            },
        }
        : {
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.9)), url(${imageSrc})`,
            backgroundRepeat: 'no-repeat',
        }
    
    return (
        <Box
            component={'section'}
            aria-label={rest['aria-label']}
            sx={{
                backgroundSize: 'cover',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                position: 'relative',
                width: '100%',
                gap: 3,
                p: 4,
                ...backgroundImageStyle,
                backgroundPosition: props?.backgroundPosition || 'center',
                minHeight: height,
            }}
        >
            {isDev && (
                <Box sx={{width: '100%', position: 'absolute', top: 0}}>
                    <Divider textAlign='left'>
                        <Typography
                            variant='caption'
                            color='secondary'
                        >
                            {rest['aria-label']}
                        </Typography>
                    </Divider>
                </Box>
            )}
            {children}
        </Box>
    )
}

export default Index


